import React, { useEffect, useState } from 'react';
import './ChatPage.css';

const ChatPage = () => {
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);

  const backendBase =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    (window.location.hostname === 'localhost'
      ? 'http://localhost:5001'
      : 'https://pickem-backend-2025.onrender.com');

  const fetchMessages = () => {
    fetch(`${backendBase}/api/chat`, { cache: 'no-store' })
      .then(res => res.json())
      .then(data =>
        setMessages((Array.isArray(data) ? data : []).slice().reverse())
      )
      .catch(err => console.error('Failed to load chat:', err));
  };

  useEffect(() => {
    fetchMessages();
    const id = setInterval(fetchMessages, 5000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendMessage = async () => {
    if (!name || !message) return;

    try {
      // Check roster before posting
      const check = await fetch(
        `${backendBase}/api/check-roster?name=${encodeURIComponent(name)}`
      );
      const valid = await check.json();

      if (!valid.allowed) {
        alert('Only registered game names may post in chat.');
        return;
      }

      // Send message if valid
      await fetch(`${backendBase}/api/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, message }),
      }).catch(() => {});

      setMessage('');
      fetchMessages();
    } catch (err) {
      console.error('Error sending message:', err);
    }
  };

  return (
    <div className="chat-container">
      <div className="chat-box">
        {messages.length === 0 ? (
          <p className="no-messages">No messages yet</p>
        ) : (
          messages.map((msg, index) => (
            <div key={index} className="chat-message">
              <strong>{msg.name}:</strong> {msg.message}
            </div>
          ))
        )}
      </div>
      <input
        className="chat-input"
        type="text"
        placeholder="Enter your game name"
        value={name}
        onChange={e => setName(e.target.value)}
      />
      <textarea
        className="chat-textarea"
        placeholder="Type your message"
        value={message}
        onChange={e => setMessage(e.target.value)}
      />
      <button className="chat-button" onClick={sendMessage}>
        Send
      </button>
    </div>
  );
};

export default ChatPage;
